import qsa from '../../scripts/util/DOM/qsa';
import qs from '../../scripts/util/DOM/qs';
import addClass from '../../scripts/util/DOM/addClass';
import bindEvent from '../../scripts/util/bindEvent';

const selectors = {
	list: '.list_links',
	select: '.js-select > select'
};

const classes = {
	show: 'list_show'
};

const mobile = window.innerWidth <= 768;
const lists = qsa(selectors.list);

const refs = {
	prev: lists[0]
};

const hideList = list => {
	list.classList.remove(classes.show);
};

const hidePrevList = index => {
	hideList(refs.prev);

	refs.prev = lists[index];
};

const showListByIndex = index => {
	if (lists[index] === refs.prev) {
		return;
	}

	hidePrevList(index);
	addClass(classes.show)(lists[index]);
};

const showList = () => {
	const select = qs(selectors.select);
	const index = select.selectedIndex;
	showListByIndex(index);
};

const render = () => {
	if (mobile) {
		addClass(classes.show)(refs.prev);
		bindEvent(selectors.select, 'change', showList);
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/support-category/select.js